(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .directive('sgProjectSubmodule', sgProjectSubmodule);

  function sgProjectSubmodule () {

    return {
      templateUrl: 'app-legacy/components/sg-project-submodule/sg-project-submodule.html',
      restrict: 'E',
      transclude: true,
      controller: 'ProjectInfoElementCtrl',
      controllerAs: 'ProjectElCtrl'
    };
  }

})();
